import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=37b9aaac&scoped=true&"
import script from "./bargain.vue?vue&type=script&lang=ts&"
export * from "./bargain.vue?vue&type=script&lang=ts&"
import style0 from "./bargain.vue?vue&type=style&index=0&id=37b9aaac&lang=stylus&scoped=true&"
import style1 from "./bargain.vue?vue&type=style&index=1&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "37b9aaac",
  null
  
)

export default component.exports